import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../_services/admin.service';
import { AppService } from '../app.service';
import { Permissions } from '../_services/permissions';
import {ACLFeature} from '../_models/acl-feature';

const log = Log.create('Management');

@Component({
  selector: 'edit-management',
  styleUrls: ['management.less'],
  templateUrl: 'management.component.html'
})

export class ManagementComponent implements OnInit, OnDestroy {

  driverGroups: Array<string> = [];
  driverType: string;
  regions = ['EMEA', 'CN', 'ROA', 'NA', 'SA'];

  constructor(
      private admin: AdminService,
      private appService: AppService,
      private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.appService.headerData.title = 'Management';
    this.appService.headerData.path = [];

    this.renderer.addClass(document.body, 'edit-section-management');

    this.admin.getDriverGroups().subscribe((groups) => {
      this.driverGroups = groups.map((item: any) => item.name);

      if (this.driverGroups.length === 1) {
        this.driverType = this.driverGroups[0];
      }
    });
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'edit-section-management');
  }
}



// WEBPACK FOOTER //
// ./src/app/management/management.component.ts